import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    OnInit,
    ViewEncapsulation,
    inject
} from '@angular/core';
import {cdkAnimations} from '@cdk/animations';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatInput, MatIcon, MatButton, MatAnchor, MatProgressBar } from '@cdk/angular/material';
import {Observable, Subject} from 'rxjs';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {LoginService} from '../../../../app/main/auth/login/login.service';
//ALTERADO PELA PGE-RS: comentado import { UpperCasePipe } from '@angular/common';
import { MatFormField, MatLabel, MatSuffix, MatError } from '@angular/material/form-field';

import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
    selector: 'cdk-login-dialog',
    templateUrl: './cdk-login-dialog.component.html',
    styleUrls: ['./cdk-login-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    animations: cdkAnimations,
    imports: [MatDialogTitle, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatError, MatButton, MatAnchor, MatProgressBar]
})
export class CdkLoginDialogComponent implements OnInit {
    private _changeDetectorRef = inject(ChangeDetectorRef);
    dialogRef = inject<MatDialogRef<CdkLoginDialogComponent>>(MatDialogRef);
    data = inject(MAT_DIALOG_DATA);
    private _formBuilder = inject(FormBuilder);
    _loginService = inject(LoginService);


    loading$: Subject<boolean>;
    loading: boolean;

    loadingConfig$: Observable<boolean>;
    loadingConfig: boolean;

    config$: Observable<any>;
    config: any;

    errorMessage$: Observable<any>;
    errorMessage: any;

    tipoLogin: string;

    form: FormGroup;
    private _destroyRef = inject(DestroyRef);

    constructor() {
        const data = this.data;

        this.loading$ = data.loading$;
        this.config$ = data.config$;
        this.loadingConfig$ = data.loadingConfig$;
        this.errorMessage$ = data.errorMessage$;

        this.tipoLogin = this._loginService.getLoginType()?? 'interno';

        this.form = this._formBuilder.group({
            tipoLogin: [this.tipoLogin, [Validators.required]],
            username: [data.username, [Validators.required]],
            password: ['', Validators.required]
        });
    }

    ngOnInit(): void {
        this.loading$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((value) => {
            this.loading = value;
        });
        this.config$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((value) => {
            this.config = value;
            this.initByAtivos();
        });
        this.loadingConfig$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((value) => {
            this.loadingConfig = value;
            this.initByAtivos();
        });
        this.errorMessage$.pipe(takeUntilDestroyed(this._destroyRef)).subscribe((value) => {
            this.errorMessage = value;
        });
    }

    initByAtivos() {
        if(this.config?.tiposLogin.includes('login_interno_ativo')) {
            this.tipoLogin = this._loginService.getLoginType()?? 'interno';
        } else if(this.config?.tiposLogin.includes('login_ldap_ativo')) {
            this.tipoLogin = this._loginService.getLoginType()?? 'ldap';
        } else if(this.config?.tiposLogin.includes('login_govbr_ativo')) {
            this.tipoLogin = this._loginService.getLoginType()?? 'govBr';
        }
    }

    onSubmit(values): void {
        this.dialogRef.close(values);
    }

    /* ALTERADO PELA PGE-RS: permitir inferir se o login será por CPF ou pelo usuário de rede. */
    onChangeTipoLogin(tipo): void {
        this._loginService.setLoginType(tipo);
        this.form.get('tipoLogin').setValue(tipo);
        this._changeDetectorRef.markForCheck();
    }

    /* ALTERADO PELA PGE-RS: método criado para alternar automaticamente entre o login da rede ou pelo CPF: se digitar somente números, é pelo CPF, se não, é pela rede (ldap). */
    onChangeTipoLogin2(): void {
        const v = this.form.get('username').value;
        if (!v) return;
        if (isNaN(v.substring(0, 3))) {
            this.onChangeTipoLogin('ldap');
        } else {
            this.onChangeTipoLogin('interno');
        }
    }

}
